import React, { useState, useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import TableContainer from "../../Components/Common/TableContainer";
import { Col, Row, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import { toast, ToastContainer } from "react-toastify";

import DeleteModal from "Components/Common/DeleteModal";
import { getPaymentHistory } from "utils/apiService";

function PaymentHistory() {
  document.title = "Payment History | Admin";

  const [payments, setPayments] = useState([]);

  useEffect(() => {
    fetchPaymentHistory();
  }, []);

  const fetchPaymentHistory = async () => {
    try {
      const data = await getPaymentHistory();
      setPayments(data.response || []);
    } catch (err) {
      console.error("Failed to fetch payment history:", err);
      toast.error("Failed to load payment history.");
    }
  };

  const handleWhatsApp = (phoneNumber: string) => {
    if (phoneNumber) {
      const formattedNumber = phoneNumber.replace(/\D/g, "");
      window.open(`https://wa.me/${formattedNumber}`, "_blank");
    } else {
      alert("Phone number not available");
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Sr No.",
        cell: (cellProps) => {
          // Adding 1 because array index starts from 0
          return cellProps.row.index + 1;
        },
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Student Name",
        accessorKey: "student_name",
      },
      {
        header: "Email",
        accessorKey: "student_email",
      },
      {
        header: "Phone",
        accessorKey: "student_phone",
        cell: ({ row }) => {
          const phone: string = row.original.student_phone || "";
          const rawCode: string = row.original.student_country_code || "";

          if (!phone && !rawCode) return "";

          const code = rawCode
            ? rawCode.startsWith("+")
              ? rawCode
              : `+${rawCode}`
            : "";

          return code ? `${code} ${phone}` : phone;
        },
      },
      {
        header: "Payment ID",
        accessorKey: "payment_id",
      },
      {
        header: "Service Name",
        accessorKey: "service_name",
      },
      {
        header: "Date",
        accessorKey: "date",
        cell: ({ row }) => {
          const dateValue = row.original.date;
          if (!dateValue) return "";

          // If the API returns YYYY-MM-DD or an ISO string, normalize via Date
          const date = new Date(dateValue);
          if (!isNaN(date.getTime())) {
            const dd = String(date.getDate()).padStart(2, "0");
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const yyyy = date.getFullYear();
            return `${dd}-${mm}-${yyyy}`;
          }

          // Fallback: if already in YYYY-MM-DD format, format manually
          const parts = String(dateValue).split("-");
          if (parts.length === 3) {
            const [yyyy, mm, dd] = parts;
            return `${dd.padStart(2, "0")}-${mm.padStart(2, "0")}-${yyyy}`;
          }

          return String(dateValue);
        },
      },
      {
        header: "Actions",
        accessorKey: "actions",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps) => {
          const phone = cellProps.row.original.student_phone;
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => handleWhatsApp(phone)}
              >
                <i className="mdi mdi-whatsapp font-size-18" />
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs breadcrumbItem="Payment History" />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  {payments.length > 0 ? (
                    <TableContainer
                      columns={columns}
                      data={payments}
                      isGlobalFilter={false}
                      isAddButton={false}
                      customPageSize={10}
                      isPagination={true}
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100"
                      theadClass="table-light"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="align-middle table-nowrap dt-responsive nowrap w-100">
                        <thead className="table-light">
                          {columns.map((column) => (
                            <th key={column.accessorKey}>{column.header}</th>
                          ))}
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan={columns.length} className="text-center">
                              <div className="py-4">No Data Found</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}

export default PaymentHistory;
